import { ComponentPropsWithoutRef, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { MoreVert } from '@mui/icons-material';
import { Button, Menu } from 'melp-design/components';
import { Divider, Stack } from '@mui/material';

interface Props
  extends Omit<
    ComponentPropsWithoutRef<typeof Menu>,
    'label' | 'icon' | 'expandIndicator'
  > {
  type?: 'comfort' | 'compact' | 'spread';
}

export const ActionsMenu: FC<Props> = ({ type = 'comfort', ...menuProps }) => {
  const { t } = useTranslation();

  if (type === 'spread') {
    return (
      <Stack flexDirection="row" display="inline-flex" gap={1}>
        {menuProps.items.map((item, i) => {
          if (item === null)
            return (
              <Divider
                orientation="vertical"
                variant="middle"
                flexItem
                key={String(i)}
              />
            );

          return (
            <Button
              label={item.label}
              onClick={item.onClick}
              icon={item.icon}
              disabled={item.disabled || menuProps.disabled}
              variant={
                item.color === 'error'
                  ? 'danger-outline'
                  : item.color === 'primary'
                  ? 'primary'
                  : item.color === 'textPrimary'
                  ? 'secondary'
                  : 'neutral-outline'
              }
              size="sm"
              tooltip={item.tooltip}
              key={String(i)}
            />
          );
        })}
      </Stack>
    );
  }

  return (
    <Menu
      {...(type === 'comfort'
        ? {
            label: t('common.actions'),
          }
        : type === 'compact'
        ? {
            icon: MoreVert,
            expandIndicator: false,
          }
        : {})}
      {...menuProps}
    />
  );
};
